import { Icon, ICONS } from 'components/Icon';
import * as React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { Image } from 'expo-image';
import { Pressable } from './Pressable';
import { Svg } from './Svg/Svg';

interface AnchorProps {
  onPress?: () => void;
  size?: number;
  style?: StyleProp<ViewStyle>;
  svgData?: string;
  imageData?: string;
  imagePadding?: number;
  iconPadding?: number;
  svgPadding?: number;
  imageBackgroundColor?: string;
  iconColor?: string;
  icon?: ICONS;
  resizeMode?: 'cover' | 'contain';
}

const SIZE = 36;

export const Avatar: React.FC<AnchorProps> = ({
  onPress,
  icon = ICONS.ImageThin,
  size = SIZE,
  style,
  imageData,
  svgData,
  imageBackgroundColor,
  imagePadding = 0,
  iconPadding = 0,
  svgPadding = 0,
  iconColor,
  resizeMode = 'cover',
}) => {
  const imageSize = size - imagePadding * 2;
  const svgSize = size - svgPadding * 2;
  const iconSize = size - iconPadding * 2;
  return (
    <Pressable
      onPress={onPress}
      style={[
        {
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: imageBackgroundColor || '#999999',
          overflow: 'hidden',
        },
        style,
      ]}
    >
      {svgData ? (
        <Svg
          data={svgData}
          width={svgSize}
          height={svgSize}
          style={{ margin: svgPadding, resizeMode }}
        />
      ) : imageData ? (
        <Image
          source={{ uri: imageData }}
          contentFit={resizeMode}
          style={{
            height: imageSize,
            width: imageSize,
            margin: imagePadding,
          }}
        />
      ) : (
        <Icon
          source={icon}
          size={iconSize}
          color={iconColor || '#ffffff'}
          style={{ margin: iconPadding }}
        />
      )}
    </Pressable>
  );
};
